export function roundToWholeNumber(value: number, to: number): number {
    const resto = value % to;
    if (resto <= to / 2) {
        return value - resto;
    } else {
        return value + to - resto;
    }
}
